module.exports = __webpack_public_path__ + "static/media/design-studio.ef57dfb4.svg";